import React, {useEffect, useState} from "react";
import {css} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {mb, mv, onDesktop} from "@pg-design/helpers-css";
import {Highlight, Text} from "@pg-design/text-module";

import {OfferDisplayType} from "../../../offer/helpers/OfferDisplayType";
import {OfferType} from "../../../offer/types/OfferType";
import {IVendorOfferWithoutVendorConfiguration} from "../../../offer/types/VendorOffersListResponse";
import {useAppDispatch, useAppSelector} from "../../../store/hooks";
import {useGetVendorDetailOffersQuery} from "../../api/get_vendor_detail_offers";
import {VendorDetailSoldOffersPageSize} from "../../constants/VendorDetailSoldOffersPageSize";
import {resetSoldOffersPage, setSoldOffersNextPage} from "../../state/vendor_offer_list_slice";
import {IVendorDetail} from "../../types/IVendorDetail";
import {convertToVendorDetailViewOffersPayload} from "../../utils/convert_to_vendor_detail_view_offers_payload";
import {VendorDetailSoldOfferBox, VendorDetailSoldOfferBoxProps} from "./boxes/VendorDetailSoldOfferBox";

interface ISoldOffer {
    vendorSlug: VendorDetailSoldOfferBoxProps["vendorSlug"];
    vendorDetail: IVendorDetail;
}

interface ISoldOfferList extends Omit<ISoldOffer, "vendorDetail"> {
    offers: IVendorOfferWithoutVendorConfiguration[];
}

const VendorDetailSoldList: React.FC<ISoldOfferList> = ({vendorSlug, offers}) => (
    <ul css={soldOffersList}>
        {offers.map((offer) => (
            <li key={offer.id} css={[mv(2), onDesktop(mv(3))]}>
                <VendorDetailSoldOfferBox offer={offer} vendorSlug={vendorSlug} />
            </li>
        ))}
    </ul>
);

export const VendorDetailSoldOffers = (props: ISoldOffer) => {
    const {vendorSlug, vendorDetail} = props;
    const dispatch = useAppDispatch();
    const [visibleSoldOffers, setVisibleSoldOffers] = useState<IVendorOfferWithoutVendorConfiguration[]>([]);
    const page = useAppSelector((state) => state.vendorDetailViewSlice.soldOffersListParams.page);
    const offersSold = props.vendorDetail.stats.offers_count_sold;

    const fullQuerySoldOffers = {
        ...convertToVendorDetailViewOffersPayload({vendorId: vendorDetail.id, region: null, displayType: OfferDisplayType.SOLD}),
        limited_presentation: undefined,
        page_size: VendorDetailSoldOffersPageSize,
        page,
        type: [OfferType.FLAT, OfferType.HOUSE, OfferType.COMMERCIAL]
    };
    const {data: soldOffers} = useGetVendorDetailOffersQuery(fullQuerySoldOffers);

    useEffect(() => {
        if (soldOffers?.results && page > 1) {
            setVisibleSoldOffers((prevOffers) => [...prevOffers, ...soldOffers.results]);
        }
        if (soldOffers?.results && page === 1) {
            setVisibleSoldOffers(soldOffers.results);
        }
    }, [soldOffers]);

    return (
        <>
            {offersSold > 0 && (
                <Text as="h2" variant="headline_3" css={[mb(3), onDesktop(mb(5))]}>
                    Zakończyliśmy sprzedaż <Highlight>{offersSold} inwestycji</Highlight>
                </Text>
            )}

            {visibleSoldOffers.length > 0 && <VendorDetailSoldList offers={visibleSoldOffers} vendorSlug={vendorSlug} />}

            {offersSold > VendorDetailSoldOffersPageSize * page && (
                <Button variant="highlight_primary" onClick={() => dispatch(setSoldOffersNextPage())}>
                    Pokaż więcej inwestycji
                </Button>
            )}

            {offersSold > VendorDetailSoldOffersPageSize && offersSold <= VendorDetailSoldOffersPageSize * page && (
                <Button variant="highlight_primary" onClick={() => dispatch(resetSoldOffersPage())}>
                    Pokaż mniej inwestycji
                </Button>
            )}
        </>
    );
};

const soldOffersList = css`
    list-style: none;
    padding-left: 0;
    margin: 0;
`;
import React, {useEffect, useState} from "react";
import {css} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {mb, mv, onDesktop} from "@pg-design/helpers-css";
import {Highlight, Text} from "@pg-design/text-module";

import {OfferDisplayType} from "../../../offer/helpers/OfferDisplayType";
import {OfferType} from "../../../offer/types/OfferType";
import {IVendorOfferWithoutVendorConfiguration} from "../../../offer/types/VendorOffersListResponse";
import {useAppDispatch, useAppSelector} from "../../../store/hooks";
import {useGetVendorDetailOffersQuery} from "../../api/get_vendor_detail_offers";
import {VendorDetailSoldOffersPageSize} from "../../constants/VendorDetailSoldOffersPageSize";
import {resetSoldOffersPage, setSoldOffersNextPage} from "../../state/vendor_offer_list_slice";
import {IVendorDetail} from "../../types/IVendorDetail";
import {convertToVendorDetailViewOffersPayload} from "../../utils/convert_to_vendor_detail_view_offers_payload";
import {VendorDetailSoldOfferBox, VendorDetailSoldOfferBoxProps} from "./boxes/VendorDetailSoldOfferBox";

interface ISoldOffer {
    vendorSlug: VendorDetailSoldOfferBoxProps["vendorSlug"];
    vendorDetail: IVendorDetail;
}

interface ISoldOfferList extends Omit<ISoldOffer, "vendorDetail"> {
    offers: IVendorOfferWithoutVendorConfiguration[];
}

const VendorDetailSoldList: React.FC<ISoldOfferList> = ({vendorSlug, offers}) => (
    <ul css={soldOffersList}>
        {offers.map((offer) => (
            <li key={offer.id} css={[mv(2), onDesktop(mv(3))]}>
                <VendorDetailSoldOfferBox offer={offer} vendorSlug={vendorSlug} />
            </li>
        ))}
    </ul>
);

export const VendorDetailSoldOffers = (props: ISoldOffer) => {
    const {vendorSlug, vendorDetail} = props;
    const dispatch = useAppDispatch();
    const [visibleSoldOffers, setVisibleSoldOffers] = useState<IVendorOfferWithoutVendorConfiguration[]>([]);
    const page = useAppSelector((state) => state.vendorDetailViewSlice.soldOffersListParams.page);
    const offersSold = props.vendorDetail.stats.offers_count_sold;

    const fullQuerySoldOffers = {
        ...convertToVendorDetailViewOffersPayload({vendorId: vendorDetail.id, region: null, displayType: OfferDisplayType.SOLD}),
        limited_presentation: undefined,
        page_size: VendorDetailSoldOffersPageSize,
        page,
        type: [OfferType.FLAT, OfferType.HOUSE, OfferType.COMMERCIAL]
    };
    const {data: soldOffers} = useGetVendorDetailOffersQuery(fullQuerySoldOffers);

    useEffect(() => {
        if (soldOffers?.results && page > 1) {
            setVisibleSoldOffers((prevOffers) => [...prevOffers, ...soldOffers.results]);
        }
        if (soldOffers?.results && page === 1) {
            setVisibleSoldOffers(soldOffers.results);
        }
    }, [soldOffers]);

    return (
        <>
            {offersSold > 0 && (
                <Text as="h2" variant="headline_3" css={[mb(3), onDesktop(mb(5))]}>
                    Zakończyliśmy sprzedaż <Highlight>{offersSold} inwestycji</Highlight>
                </Text>
            )}

            {visibleSoldOffers.length > 0 && <VendorDetailSoldList offers={visibleSoldOffers} vendorSlug={vendorSlug} />}

            {offersSold > VendorDetailSoldOffersPageSize * page && (
                <Button variant="highlight_primary" onClick={() => dispatch(setSoldOffersNextPage())}>
                    Pokaż więcej inwestycji
                </Button>
            )}

            {offersSold > VendorDetailSoldOffersPageSize && offersSold <= VendorDetailSoldOffersPageSize * page && (
                <Button variant="highlight_primary" onClick={() => dispatch(resetSoldOffersPage())}>
                    Pokaż mniej inwestycji
                </Button>
            )}
        </>
    );
};

const soldOffersList = css`
    list-style: none;
    padding-left: 0;
    margin: 0;
`;
